import React from 'react';
import PropTypes from 'prop-types';

const CoverBig = ({ cover }) => {
  const coverURL = cover !== 'false' ? cover : '/placeholders/cover.png';
  return (
    <div className="cover-big-wrapper">
      <div className="cover-big-img" style={{ backgroundImage: `url(${coverURL})` }} />
    </div>
  );
};

CoverBig.propTypes = {
  cover: PropTypes.string.isRequired
};

export default CoverBig;
